import React from 'react';
import { HeartIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-16">
          {/* For */}
          <div className="bg-amber-50 rounded-2xl p-8 border border-amber-100" data-id="element-17">
            <div className="flex items-center mb-6" data-id="element-18">
              <HeartIcon className="w-8 h-8 text-amber-600 mr-3" data-id="element-19" />
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-stone-900" data-id="element-20">
                Esto es para usted si...
              </h2>
            </div>
            <ul className="space-y-4" data-id="element-21">
              <li className="flex items-start" data-id="element-22">
                <span className="text-amber-600 mr-2 text-xl" data-id="element-23">•</span>
                <span className="text-lg text-stone-700" data-id="element-24">
                  Mujeres de 65 años o más que viven en USA o Latinoamérica.
                </span>
              </li>
              <li className="flex items-start" data-id="element-25">
                <span className="text-amber-600 mr-2 text-xl" data-id="element-26">•</span>
                <span className="text-lg text-stone-700" data-id="element-27">
                  Abuelas que quieren seguir siendo el pilar de sabiduría en su
                  hogar.
                </span>
              </li>
              <li className="flex items-start" data-id="element-28">
                <span className="text-amber-600 mr-2 text-xl" data-id="element-29">•</span>
                <span className="text-lg text-stone-700" data-id="element-30">
                  Mujeres que han sentido pequeños olvidos y quieren actuar hoy
                  mismo por prevención.
                </span>
              </li>
              <li className="flex items-start" data-id="element-31">
                <span className="text-amber-600 mr-2 text-xl" data-id="element-32">•</span>
                <span className="text-lg text-stone-700" data-id="element-33">
                  Hijas que buscan un regalo con propósito para sus madres.
                </span>
              </li>
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-stone-50 rounded-2xl p-8 border border-stone-200" data-id="element-34">
            <div className="flex items-center mb-6" data-id="element-35">
              <XCircleIcon className="w-8 h-8 text-stone-400 mr-3" data-id="element-36" />
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-stone-900" data-id="element-37">
                Esto NO es para usted si...
              </h2>
            </div>
            <ul className="space-y-4" data-id="element-38">
              <li className="flex items-start" data-id="element-39">
                <span className="text-stone-400 mr-2 text-xl" data-id="element-40">•</span>
                <span className="text-lg text-stone-700" data-id="element-41">
                  Personas que buscan una cura médica mágica para enfermedades
                  avanzadas.
                </span>
              </li>
              <li className="flex items-start" data-id="element-42">
                <span className="text-stone-400 mr-2 text-xl" data-id="element-43">•</span>
                <span className="text-lg text-stone-700" data-id="element-44">
                  Quienes no están dispuestas a dedicar 15 minutos al día a su
                  entrenamiento.
                </span>
              </li>
              <li className="flex items-start" data-id="element-45">
                <span className="text-stone-400 mr-2 text-xl" data-id="element-46">•</span>
                <span className="text-lg text-stone-700" data-id="element-47">
                  Personas que prefieren métodos puramente clínicos y fríos.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}